import React from 'react'
import { IonPage } from '@ionic/react'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import DoNotResuscitateContent from './DoNotResuscitate.component'

const DoNotResuscitate: React.FC = () => {
  return (
    <IonPage id='DoNotResuscitate'>
      <PCRHeader />
      <DoNotResuscitateContent />
    </IonPage>
  )
}

export default DoNotResuscitate
